/**
 * Модуль для работы с промокодами на странице продукта
 */

(function() {
    'use strict';

    /**
     * Инициализация обработки промокодов
     */
    function initPromocodeHandling() {
        const applyPromoBtn = document.getElementById('apply-promo');
        
        if (applyPromoBtn) {
            applyPromoBtn.addEventListener('click', function(e) {
                e.preventDefault();
                handlePromocodeApplication();
            });
        }
    }

    /**
     * Обработка применения промокода
     */
    function handlePromocodeApplication() {
        const promocodeInput = document.getElementById('promocode');
        const promoMessage = document.getElementById('promo-message');

        promoMessage.style.display = 'block';

        if (!promocodeInput.value) {
            promoMessage.innerHTML = '<span class="text-danger">Введите промокод</span>';
            return;
        }

        const requestBody = {
            promocode: promocodeInput.value,
            package_id: window.currentPackageId
        };

        // Добавляем user_id если пользователь авторизован
        if (window.currentUserId) {
            requestBody.user_id = window.currentUserId;
        }

        fetch(window.promocodeCheckUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': window.csrfToken
            },
            body: JSON.stringify(requestBody)
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                promoMessage.innerHTML = '<span class="text-success">' + data.message + '</span>';

                // Prices and the signed PayKeeper orderid are rendered by the server from the promo cookie
                window.location.reload();
            } else {
                promoMessage.innerHTML = '<span class="text-danger">' + data.message + '</span>';
            }
        })
        .catch(error => {
            promoMessage.innerHTML = '<span class="text-danger">Произошла ошибка при проверке промокода</span>';
        });
    }

    // Инициализация при загрузке страницы
    document.addEventListener('DOMContentLoaded', function() {
        initPromocodeHandling();
    });

})();
